<template>
<div class="link" :title="text" :style="{ maxHeight: col.maxHeight }">
  <span @click="clickHandler">{{ text }}</span>
</div>
</template>

<script>
export default {
  name: 'Link',
  props: ['data', 'row', 'col'],
  computed: {
    text () {
      return this.data || '';
    },
  },
  methods: {
    clickHandler (event) {
      this.$emit('click', {
        event,
        type: 'Link',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.link {
    position: relative;
    &:hover>span {
        cursor: pointer;
        color: #2ec2ff;
        text-decoration: underline;
    }
}
</style>
